<div class="discussion" [class.shadow-deep-heavy]="open">
  <div class="message-container scroll-y" #messageRef>
    @for (group of groupedByDate; track group) {
      <div>
        <div class="date-bar">
          <div class="bar"></div>
          <div class="date">{{ group.date | date: 'd MMMM' }}</div>
          <div class="bar"></div>
        </div>
        @for (message of group.messages; track message; let i = $index) {
          <div>
            <div class="clearfix">
              <div class="message" [class.lead-reviewer]="message.userRole === 1">
                <p>{{message.text}}</p>
                @if (i === 0 || message.ticks - group.messages[i-1].ticks > 60000) {
                  <span class="message-time">
                  {{message.time}} </span>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
  <div style="display:none" class="send-box-container" >
    <div class="send-box" [class.has-focus]="hasFocus">
      <div class="message-box" (focus)="hasFocus = true" (blur)="hasFocus=false" #sendboxRef placeholder="Type a message here"
      contenteditable=""></div>
      @if (!sending) {
        <button type="button" class="btn btn-default shadow" (click)="send()">Send</button>
      }
      @if (sending) {
        <app-spinner [small]="true"></app-spinner>
      }

    </div>
  </div>
</div>